module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    class: _vm.short()
  }, [_c('app-header'), _c('div', {
    staticClass: "container shop-proposals",
    class: _vm.short()
  }, [_c('div', {
    staticClass: "row"
  }, [_c('sub-menu')], 1), (_vm.shopCallbackFlag) ? _c('div', {
    staticClass: "row bg04"
  }, [_c('div', {
    staticClass: "shop-proposals__heading"
  }, [(_vm.proposeTask) ? _c('h2', {
    staticClass: "shop-proposals__heading__balloon"
  }, [_c('div', {
    staticClass: "balloon"
  }, [_c('p', [_vm._v(_vm._s(_vm.proposeTask.attributes['task-title']))])])]) : _c('h2', {
    staticClass: "shop-proposals__heading__title"
  }, [_vm._m(0), _c('span', {
    staticClass: "shop-proposals__heading__link"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.proposeHelp()
      }
    }
  }, [_vm._v("ヘルプ")])])])]), _c('div', {
    staticClass: "shop-proposals__tabs"
  }, [_c('ul', {
    staticClass: "shop-proposals__tabs__wrap"
  }, [_vm._m(1), _c('li', {
    staticClass: "shop-proposals__tabs__item -adopt",
    on: {
      "click": function($event) {
        _vm.goProposeAdoptList()
      }
    }
  }, [_c('span', [_vm._v("採用状況")])]), _c('li', {
    staticClass: "shop-proposals__tabs__item -search",
    on: {
      "click": function($event) {
        _vm.goProposeSearchList()
      }
    }
  }, [_c('span', [_vm._v("検索")])])])]), (_vm.searchCallbackFlag) ? _c('div', {
    staticClass: "shop-proposals__tab-body bg05"
  }, [_vm._l((_vm.proposes), function(propose, index) {
    return _c('div', {
      staticClass: "user-post"
    }, [_c('div', {
      staticClass: "user-post__thumb",
      on: {
        "click": function($event) {
          _vm.goProposePersonalList(propose.attributes['user-id'])
        }
      }
    }, [(_vm.getProposeProfileImagePath(propose.attributes)) ? _c('a', [_c('img', {
      attrs: {
        "src": _vm.getProposeProfileImagePath(propose.attributes) + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    })]) : _c('a', [_c('img', {
      attrs: {
        "src": require("../images/img_profile.png")
      }
    })])]), _c('div', {
      staticClass: "user-post__body"
    }, [_c('p', {
      staticClass: "user-post__body__info"
    }, [_c('a', {
      staticClass: "user-post__body__name",
      on: {
        "click": function($event) {
          _vm.goProposePersonalList(propose.attributes['user-id'])
        }
      }
    }, [_vm._v(_vm._s(propose.attributes['user-name']) + " " + _vm._s(propose.attributes['user-firstname']))]), _c('span', {
      staticClass: "user-post__body__time",
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v(_vm._s(propose.attributes['shop-name']) + " ")]), _c('br'), _c('span', {
      staticClass: "user-post__body__time"
    }, [_vm._v(_vm._s(propose.attributes['contribution-at-format']))])]), _c('a', {
      staticClass: "user-post__body__link",
      on: {
        "click": function($event) {
          _vm.goProposeDetail(propose.id)
        }
      }
    }, [_c('h3', {
      staticClass: "user-post__body__title",
      staticStyle: {
        "word-break": "break-word"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.content(propose.attributes['propose-title']))
      }
    }), _c('p', {
      staticClass: "user-post__body__excerpt",
      staticStyle: {
        "word-break": "break-word"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getProposeContent(propose.attributes['propose-content']))
      }
    }), (_vm.getProposeImagePath(propose.attributes)) ? _c('div', {
      staticClass: "user-post__body__images"
    }, [_c('img', {
      attrs: {
        "src": _vm.getProposeImagePath(propose.attributes) + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    }), (_vm.getProposeImageCount(propose.attributes)) ? _c('span', {
      staticClass: "user-post__body__images__num"
    }, [_vm._v(_vm._s(_vm.getProposeImageCount(propose.attributes)))]) : _vm._e()]) : _vm._e()]), _c('div', {
      staticClass: "user-post__body__like-btn",
      class: _vm.getGoodClass(propose.attributes['good-id']),
      on: {
        "click": function($event) {
          _vm.toggleGood(propose.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(propose.attributes['goods-count']))])])])])
  }), (_vm.nextPage) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default next-page-search-btn",
    on: {
      "click": function($event) {
        _vm.search(true)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Read More')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])])]) : _vm._e()], 2) : _vm._e(), (_vm.searchCallbackFlag && _vm.proposes.length == 0) ? _c('div', {
    staticClass: "div text-center bg05"
  }, [_c('p', {
    staticClass: "no_propose_txt brown"
  }, [_vm._v("提案の投稿がまだありませんニャン。")]), _c('p', [_vm._v("素敵な提案")]), _c('p', [_vm._v("お待ちしてますニャン！")])]) : _vm._e()]) : _vm._e(), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "proposeHelpModalButton",
      "type": "button",
      "data-backdrop": "static",
      "data-toggle": "modal",
      "data-target": "#proposeHelpModal"
    }
  }, [_vm._v("モーダル発火用")]), _vm._m(2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "shop-proposals__heading__img"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_title_03.png"),
      "alt": "提案ありがとうだニャン！"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "shop-proposals__tabs__item -all -active"
  }, [_c('span', [_vm._v("全店舗")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-modal",
    attrs: {
      "id": "proposeHelpModal"
    }
  }, [_c('div', {
    staticClass: "help-modal__body bg03",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h4', {
    staticClass: "heading_01 mb25"
  }, [_vm._v("こんな投稿"), _c('br'), _vm._v("待ってるニャン♪")]), _c('div', {
    staticClass: "box_01 help-modal__body__txt -proposal"
  }, [_c('p', [_vm._v("お客様は勿論、会社のみんなにも、「居心地のいい、素敵な会社だ」と思ってもらえるような、素敵なアイディア待ってるニャン♪")]), _c('p', [_vm._v("みんなの声を反映して、より一層毎日を快適に過ごせるようにしたいんだニャン♪")]), _c('p', [_vm._v("投稿した提案は、みんなで見れるようにタイムラインに掲載されるニャン♪")]), _c('p', [_vm._v("法律などの問題から、実現が現時点では難しい提案については、個別にお返事を差し上げますだニャン！")])]), _c('button', {
    staticClass: "btn01 moral-going__modal-btn",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', [_vm._v("閉じる")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cfddd14!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/propose-allshop-list.pug
// module id = 1385
// module chunks = 1